import { Injectable } from '@angular/core';
import { FormControlServiceBase } from '../types/form-control-service.base';

@Injectable()
export class TextFormControlService implements FormControlServiceBase<'text'> {


  constructor() {

  }

}
